export default __webpack_public_path__ + "static/media/03.3fc4d8f3.jpg";